import axios from "axios";
import authHeader from "./auth-header";
import {API_URL} from "../config";
const getPublicContent = () => {
    return axios.get(API_URL + "all");
};
const getStats = () => {
    return axios.get(API_URL + "stats", { headers: authHeader() })
};
const getUsers = () => {
    return axios.get(API_URL + "users", { headers: authHeader() })
};
const getUser = (id) => {
    return axios.get(API_URL + "user-data/" + id, { headers: authHeader() })
};

const UserService = {
    getPublicContent,
    getUsers,
    getUser,
    getStats
};

export default UserService;
